import ApiService from './ApiService'
import { getDeviceMeta } from 'utils/deviceId'

export async function apiOAuth (data) {
    return ApiService.fetchData({
        url: '/auth/userinfo',
        method: 'post',
        data
    })
}
export async function apiSignIn (data) {
    return ApiService.fetchData({
        url: '/auth/login',
        method: 'post',
        headers: {'Content-Type': 'application/json'},
        data: { ...data, ...getDeviceMeta() }
    })
}

// Танихгүй төхөөрөмжөөс нэвтрэхэд имэйлээр ирсэн OTP-г баталгаажуулж, уг
// төхөөрөмжийг итгэмжлэгдсэн болгон бүртгэнэ.
export async function apiVerifyDevice (data) {
    return ApiService.fetchData({
        url: '/auth/verify-device',
        method: 'post',
        headers: {'Content-Type': 'application/json'},
        data: { ...data, ...getDeviceMeta() }
    })
}

export async function apiSignUp (data) {
    return ApiService.fetchData({
        url: '/auth/signup',
        method: 'post',
        data
    })
}

// GSIGN/эсайн баталгаажуулалт амжилтгүй болсон, эсхүл харилцагч уг алхмыг
// дуусгалгүй орхисон тохиолдолд signup()-ээр үүссэн дутуу бүртгэлийг цуцлана.
export async function apiCancelSignup (data) {
    return ApiService.fetchData({
        url: '/auth/cancel-signup',
        method: 'post',
        data
    })
}

export async function apiSignOut () {
    return ApiService.fetchData({
        url: '/auth/logout',
        method: 'post'
    })
}

export async function apiForgotPassword (data) {
    return ApiService.fetchData({
        url: '/forgot-password',
        method: 'post',
        data
    })
}

export async function apiResetPassword (data) {
    return ApiService.fetchData({
        url: '/user/change_pass',
        method: 'post',
        data
    })
}

export async function apiCheckMonPep (params) {
    return ApiService.fetchData({
        url: '/monpep',
        method: 'get',
        params
    })
}
